
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prosjekter/[slug]",
      function () {
        return require("private-next-pages/prosjekter/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prosjekter/[slug]"])
      });
    }
  